// @ts-nocheck
import { Script } from "gatsby"
import { useEffect, useState } from "react"
import { Box, Stack, Typography } from "@mui/material"
import { gsap, ScrollTrigger } from "@ggs/ui/local/gsap"
import { useLocation } from "@reach/router"
import { SvgIcon, type FC } from ".."
import "./ChatIcon.css"

const ChatIconCTA: FC = () => {
  const location = useLocation()
  const isTripDetail = location.pathname.includes("/trips/")
  const offset = isTripDetail ? 70 : 20

  useEffect(() => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: "#chat-button",
        start: () => (window.innerWidth < 768 ? (isTripDetail ? "top 20%" : "top 90%") : "top 90%"),
        end: "+=100",
        toggleActions: "play none none reverse",
      },
    })

    tl.from("#chat-button", { opacity: 0, y: 20, duration: 0.5 })

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => {
        trigger.kill()
      })
    }
  }, [])

  const onHandleChatCTA = () => {
    if (window.Genesys) {
      window.Genesys("command", "Messenger.open")
    }
  }

  return (
    <Box
      id="chat-button"
      width={56}
      height={56}
      position="fixed"
      bottom={{ xs: offset, md: 20 }}
      right={20}
      borderRadius={100}
      justifyContent="center"
      zIndex={10000}
      alignItems="center"
      bgcolor="#38AB97"
      boxShadow="0px 0px 3.3px 0px rgba(0, 0, 0, 0.40)"
      role="button"
      aria-label="chat button"
      onClick={onHandleChatCTA}
      sx={{ "display": "flex!important", "&:hover": { cursor: "pointer" } }}
    >
      <Stack alignItems="center">
        <SvgIcon variant="speechBubble" size={22} sx={{ fill: "none" }} />
        <Typography variant="body.md" sx={{ color: "#F3F9F6", lineHeight: 1.5 }}>
          Chat
        </Typography>
      </Stack>
      <Script
        id="genesys-chat-script"
        strategy="post-hydrate"
        dangerouslySetInnerHTML={{
          __html: `
          (function (g, e, n, es, ys) {
            g['_genesysJs'] = e;
            g[e] = g[e] || function () {
              (g[e].q = g[e].q || []).push(arguments);
            };
            g[e].t = 1 * new Date();
            g[e].c = es;
            ys = document.createElement('script');
            ys.async = 1;
            ys.src = n;
            ys.charset = 'utf-8';
            document.head.appendChild(ys);
          })(window, 'Genesys', 'https://apps.cac1.pure.cloud/genesys-bootstrap/genesys.min.js', {
            environment: 'cac1',
            deploymentId: '91a139f1-c49d-436c-9e7a-95d502f7a072',
            debug: true
          });

          Genesys("subscribe", "Database.ready", function() {
            Genesys("command", "Database.set", {
              messaging: {
                customAttributes: {
                  link: window.location.href
                }
              }
            });
          });

          Genesys("subscribe", "MessagingService.conversationCleared", function() {
            Genesys("command", "Database.set", {
              messaging: {
                customAttributes: {
                  link: window.location.href
                }
              }
            });
          });
        `,
        }}
      />
    </Box>
  )
}

export default ChatIconCTA
